<template>
    <div class="pulse_satus-container" v-show="show">
        <div :class="status ? 'circle pulse green' : 'circle red'" />
        <div v-if="url"><a :href="url">{{ status ? onMessage : offMessage }}</a></div>
        <div v-else>{{ status ? onMessage : offMessage }}</div>
    </div>
</template>

<script>
export default {
    name: "PulseStatus",
    props: {
        status: {
            type: Boolean,
            required: true,
        },
        show: {
            type: Boolean,
            required: false,
            default: true
        },
        onMessage: {
            type: String,
            required: false,
            default: "Online",
        },
        offMessage: {
            type: String,
            required: false,
            default: "Offline",
        },
        url: {
            type: String,
            required: false,
        },
    },
};
</script>

<style scoped>
.green {
    background: #66ff66;
}

.red {
    background: #cecece;
}

.testmode a {
    color: #ff0000;
}

.pulse_satus-container {
    display: flex;
    align-items: center;
    column-gap: 8px;
}

.circle {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    box-shadow: 0px 0px 1px 1px #0000661a;
}

.pulse {
    animation: pulse-animation 1.5s infinite;
}

@keyframes pulse-animation {
    0% {
        box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.3);
    }
    100% {
        box-shadow: 0 0 0 10px rgba(0, 100, 0, 0);
    }
}

.master {
    color: black;
    float: right;
}

@media (max-width: 900px) {
    .master {
        display: none;
    }
}
</style>
